import { concat } from '../../helpers/common'
import { setLocalStorage } from '../../helpers/storage'

const MODULE_NAME = 'PARTNERSHIPS/'
export const SELECTED_PARTNERSHIP_ID = 'selectedPartnershipId'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION

export const GET_PARTNERSHIPS = concat(MODULE_NAME, 'GET_PARTNERSHIPS')
export const GET_PARTNERSHIPS_SUCCESS = concat(MODULE_NAME, 'GET_PARTNERSHIPS_SUCCESS')
export const GET_PARTNERSHIPS_FAILURE = concat(MODULE_NAME, 'GET_PARTNERSHIPS_FAILURE')
export const CLEAR_PARTNERSHIPS = concat(MODULE_NAME, 'CLEAR_PARTNERSHIPS')

export const SET_SELECTED_PARTNERSHIP = concat(MODULE_NAME, 'SET_SELECTED_PARTNERSHIP')
export const CLEAR_SELECTED_PARTNERSHIP = concat(MODULE_NAME, 'CLEAR_SELECTED_PARTNERSHIP')

export const CREATE_PARTNERSHIP = concat(MODULE_NAME, 'CREATE_PARTNERSHIP')
export const CREATE_PARTNERSHIP_SUCCESS = concat(MODULE_NAME, 'CREATE_PARTNERSHIP_SUCCESS')
export const CREATE_PARTNERSHIP_FAILURE = concat(MODULE_NAME, 'CREATE_PARTNERSHIP_FAILURE')
export const CLEAR_CREATE_PARTNERSHIP = concat(MODULE_NAME, 'CLEAR_CREATE_PARTNERSHIP')

export const UPDATE_PARTNERSHIP = concat(MODULE_NAME, 'UPDATE_PARTNERSHIP')
export const UPDATE_PARTNERSHIP_SUCCESS = concat(MODULE_NAME, 'UPDATE_PARTNERSHIP_SUCCESS')
export const UPDATE_PARTNERSHIP_FAILURE = concat(MODULE_NAME, 'UPDATE_PARTNERSHIP_FAILURE')
export const CLEAR_UPDATE_PARTNERSHIP = concat(MODULE_NAME, 'CLEAR_UPDATE_PARTNERSHIP')

export const DELETE_PARTNERSHIP = concat(MODULE_NAME, 'DELETE_PARTNERSHIP')
export const DELETE_PARTNERSHIP_SUCCESS = concat(MODULE_NAME, 'DELETE_PARTNERSHIP_SUCCESS')
export const DELETE_PARTNERSHIP_FAILURE = concat(MODULE_NAME, 'DELETE_PARTNERSHIP_FAILURE')
export const CLEAR_DELETE_PARTNERSHIP = concat(MODULE_NAME, 'CLEAR_DELETE_PARTNERSHIP')

export const SEND_OUTSTANDING_ACTIONS_NOTIFICATION = concat(MODULE_NAME, 'SEND_OUTSTANDING_ACTIONS_NOTIFICATION')
export const SEND_OUTSTANDING_ACTIONS_NOTIFICATION_SUCCESS = concat(
  MODULE_NAME,
  'SEND_OUTSTANDING_ACTIONS_NOTIFICATION_SUCCESS'
)
export const SEND_OUTSTANDING_ACTIONS_NOTIFICATION_FAILURE = concat(
  MODULE_NAME,
  'SEND_OUTSTANDING_ACTIONS_NOTIFICATION_FAILURE'
)

export const CLEAR_OUTSTANDING_ACTIONS_NOTIFICATION = concat(MODULE_NAME, 'CLEAR_OUTSTANDING_ACTIONS_NOTIFICATION')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

// get partnerships
export function getPartnerships(params) {
  return { type: GET_PARTNERSHIPS, params }
}

export function getPartnershipsSuccess(partnershipsData) {
  return { type: GET_PARTNERSHIPS_SUCCESS, partnershipsData }
}

export function getPartnershipsFailure(error) {
  return { type: GET_PARTNERSHIPS_FAILURE, error }
}

export function clearPartnerships() {
  return { type: CLEAR_PARTNERSHIPS }
}

// set selected partnership
export function setSelectedPartnership(partnershipData) {
  setLocalStorage(SELECTED_PARTNERSHIP_ID, partnershipData.id)

  return { type: SET_SELECTED_PARTNERSHIP, partnershipData }
}

export function clearSelectedPartnership() {
  setLocalStorage(SELECTED_PARTNERSHIP_ID, '')

  return { type: CLEAR_SELECTED_PARTNERSHIP }
}

// create partnership
export function createPartnership(partnershipData) {
  return { type: CREATE_PARTNERSHIP, partnershipData }
}

export function createPartnershipSuccess(partnershipData) {
  return { type: CREATE_PARTNERSHIP_SUCCESS, partnershipData }
}

export function createPartnershipFailure(error) {
  return { type: CREATE_PARTNERSHIP_FAILURE, error }
}

export function clearCreatePartnership() {
  return { type: CLEAR_CREATE_PARTNERSHIP }
}

// update partnership
export function updatePartnership(id, partnershipData) {
  return { type: UPDATE_PARTNERSHIP, id, partnershipData }
}

export function updatePartnershipSuccess(partnershipData) {
  return { type: UPDATE_PARTNERSHIP_SUCCESS, partnershipData }
}

export function updatePartnershipFailure(error) {
  return { type: UPDATE_PARTNERSHIP_FAILURE, error }
}

export function clearUpdatePartnership() {
  return { type: CLEAR_UPDATE_PARTNERSHIP }
}

// delete partnership
export function deletePartnership(params) {
  return { type: DELETE_PARTNERSHIP, params }
}

export function deletePartnershipSuccess(id) {
  return { type: DELETE_PARTNERSHIP_SUCCESS, id }
}

export function deletePartnershipFailure(error) {
  return { type: DELETE_PARTNERSHIP_FAILURE, error }
}

export function clearDeletePartnership() {
  return { type: CLEAR_DELETE_PARTNERSHIP }
}

// send_outstanding_actions_notification
export function sendOutstandingActionsNotification(partnershipId) {
  return { type: SEND_OUTSTANDING_ACTIONS_NOTIFICATION, partnershipId }
}

export function sendOutstandingActionsNotificationSuccess() {
  return { type: SEND_OUTSTANDING_ACTIONS_NOTIFICATION_SUCCESS }
}

export function sendOutstandingActionsNotificationFailure() {
  return { type: SEND_OUTSTANDING_ACTIONS_NOTIFICATION_FAILURE }
}

export function clearOutstandingActionsNotification() {
  return { type: CLEAR_OUTSTANDING_ACTIONS_NOTIFICATION }
}
